'use client';

import { saveFirstInterview } from 'actions/Database';
import { handleVisitsSubmit } from 'actions/Forms';
import { useAppDispatch } from 'lib/hooks';
import { useActionState, useEffect, useRef } from 'react';
import { setUserDatabase } from 'slices/userSlice';
import { ComponentFields } from 'types/content';
import { ANALYTICS_EVENTS, capture, secondsSince } from 'lib/analytics';

const VisitsForm = ({ data, onContinue }: ComponentFields) => {
  const dispatch = useAppDispatch();
  const mountTimeRef = useRef<number | null>(null);
  useEffect(() => {
    mountTimeRef.current = Date.now();
    capture(ANALYTICS_EVENTS.healthcareVisitsFormViewed);
  }, []);

  const [state, formAction, isPending] = useActionState(handleVisitsSubmit, {
    data: new FormData(),
    errors: {},
    results: {
      primaryCare: '0',
      specialist: '0',
      hospital: '0',
    },
    success: false,
  });

  useEffect(() => {
    if (state.success) {
      saveFirstInterview(state.results)
        .then((user) => {
          dispatch(
            setUserDatabase({ ...user, created_at: null, updated_at: null })
          );
        })
        .finally(() => {
          onContinue();
        });
    }
  }, [state.success]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="form-container">
      <form action={formAction}>
        <fieldset>
          <div className="form-header">
            <legend>{data.elements.title?.value}</legend>
            <p className="explanation-text">{data.elements.subtitle?.value}</p>
          </div>

          <div className="row">
            <label className="field-label" htmlFor="pcp">
              {data.elements.labelPcp?.value}
            </label>
            <input
              id="pcp"
              type="text"
              name="pcp"
              className="quarter"
              // defaultValue={Number(state.data.get('pcp')) as number}
              defaultValue={(state.data.get('pcp') as string) ?? '0'}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div className="row">
            <label className="field-label" htmlFor="specialist">
              {data.elements.labelSpecialist?.value}
            </label>
            <input
              id="specialist"
              type="text"
              name="specialist"
              className="quarter"
              defaultValue={(state.data.get('specialist') as string) ?? '0'}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div className="row">
            <label className="field-label" htmlFor="hospital">
              {data.elements.labelHospital?.value}
            </label>
            <input
              id="hospital"
              type="text"
              name="hospital"
              className="input quarter"
              defaultValue={(state.data.get('hospital') as string) ?? '0'}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <button
            className="button primary"
            type="submit"
            disabled={isPending}
            onClick={() =>
              capture(ANALYTICS_EVENTS.healthcareVisitsFormCompleted, {
                duration_seconds: secondsSince(mountTimeRef.current),
              })
            }
          >
            Submit
          </button>

          {isPending && <div className="spinner"></div>}
        </fieldset>
      </form>
    </section>
  );
};

export default VisitsForm;
